import CustomModal from '../../../../components/ModalUser'
import { Col, Row, Spin } from 'antd'
import Search from '../../../../components/SearchFilter'
import useAddOrderModalHook, { Props } from './hooks'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableAntd from '../../../../components/TableAntd'
import { useMemo } from 'react'

const columns = [
  {
    key: 'orderNo',
    dataIndex: 'orderNo',
    title: '客户订单号',
  },
  {
    key: 'blueInvoiceNum',
    dataIndex: 'blueInvoiceNum',
    title: '客户订单已开蓝票',
    render: (text: any, record: any) => {
      return record.blueInvoiceInfos
        ? record.blueInvoiceInfos
            ?.map((item: any) => item.blueInvoiceNum)
            .join(',')
        : '-'
    },
  },
  {
    key: 'returnNo',
    dataIndex: 'returnNo',
    title: '退货单号',
  },
  {
    key: 'titleOfTheContractName',
    title: '签约抬头',
    render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
  },
  {
    key: 'customerName',
    dataIndex: 'customerName',
    title: '客户名称',
  },
  {
    key: 'platform',
    dataIndex: 'platform',
    title: '下单平台',
  },
  {
    key: 'taxRate',
    dataIndex: 'taxRate',
    title: '税率',
    render: (text: number) => `${(text ?? 0) * 100}%`,
  },
  {
    key: 'returnAmount',
    dataIndex: 'returnAmount',
    title: '退货金额',
  },
]

const AddReturnOrderModal = (props: Props) => {
  const { open, type, excludeOrderIds, ...restProps } = props
  const {
    hooksState,
    handleSearchClick,
    onChangeCheck,
    modalSubmit,
    loadMoreData,
  } = useAddOrderModalHook(props)
  const { orderData, loading, pagination, checkedKeys } = hooksState

  const dataSourceMemo = useMemo(() => {
    return orderData.map((item) => {
      return {
        ...item,
        isDisabled: excludeOrderIds?.includes(item.id),
      }
    })
  }, [orderData, excludeOrderIds])
  return (
    <CustomModal
      width={1000}
      bodyStyle={{ padding: 16 }}
      {...restProps}
      open={open}
      title="新增退货单"
      okText="提交"
      modalSubmit={modalSubmit}
      useOverrideTitle={false}
    >
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <Search
            fieldsData={['orderNo', 'returnNo', 'customerName', 'platformCode']}
            onSearch={handleSearchClick}
            keyName={'REDLANDERINVOICEENTRY'}
            ScreenKey={'REDLANDERINVOICEENTRY'}
            hideScheme
          />
        </Col>
        <Col span={24}>
          <InfiniteScroll
            dataLength={orderData.length}
            next={loadMoreData}
            hasMore={orderData.length < pagination.totalCount}
            loader={<Spin spinning />}
            endMessage="已全部加载~"
            height={400}
          >
            <TableAntd
              dataSource={dataSourceMemo}
              loading={loading}
              listColumn={columns}
              scroll={{
                y: 'auto',
              }}
              onChangeCheck={onChangeCheck}
              defaultlist={checkedKeys}
              scrollStyle={{
                height: 'auto',
              }}
            />
          </InfiniteScroll>
        </Col>
      </Row>
    </CustomModal>
  )
}

export default AddReturnOrderModal
import CustomModal from '../../../../components/ModalUser'
import { Col, Row, Spin } from 'antd'
import Search from '../../../../components/SearchFilter'
import useAddOrderModalHook, { Props } from './hooks'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableAntd from '../../../../components/TableAntd'
import { useMemo } from 'react'

const columns = [
  {
    key: 'orderNo',
    dataIndex: 'orderNo',
    title: '客户订单号',
  },
  {
    key: 'blueInvoiceNum',
    dataIndex: 'blueInvoiceNum',
    title: '客户订单已开蓝票',
    render: (text: any, record: any) => {
      return record.blueInvoiceInfos
        ? record.blueInvoiceInfos
            ?.map((item: any) => item.blueInvoiceNum)
            .join(',')
        : '-'
    },
  },
  {
    key: 'returnNo',
    dataIndex: 'returnNo',
    title: '退货单号',
  },
  {
    key: 'titleOfTheContractName',
    title: '签约抬头',
    render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
  },
  {
    key: 'customerName',
    dataIndex: 'customerName',
    title: '客户名称',
  },
  {
    key: 'platform',
    dataIndex: 'platform',
    title: '下单平台',
  },
  {
    key: 'taxRate',
    dataIndex: 'taxRate',
    title: '税率',
    render: (text: number) => `${(text ?? 0) * 100}%`,
  },
  {
    key: 'returnAmount',
    dataIndex: 'returnAmount',
    title: '退货金额',
  },
]

const AddReturnOrderModal = (props: Props) => {
  const { open, type, excludeOrderIds, ...restProps } = props
  const {
    hooksState,
    handleSearchClick,
    onChangeCheck,
    modalSubmit,
    loadMoreData,
  } = useAddOrderModalHook(props)
  const { orderData, loading, pagination, checkedKeys } = hooksState

  const dataSourceMemo = useMemo(() => {
    return orderData.map((item) => {
      return {
        ...item,
        isDisabled: excludeOrderIds?.includes(item.id),
      }
    })
  }, [orderData, excludeOrderIds])
  return (
    <CustomModal
      width={1000}
      bodyStyle={{ padding: 16 }}
      {...restProps}
      open={open}
      title="新增退货单"
      okText="提交"
      modalSubmit={modalSubmit}
      useOverrideTitle={false}
    >
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <Search
            fieldsData={['orderNo', 'returnNo', 'customerName', 'platformCode']}
            onSearch={handleSearchClick}
            keyName={'REDLANDERINVOICEENTRY'}
            ScreenKey={'REDLANDERINVOICEENTRY'}
            hideScheme
          />
        </Col>
        <Col span={24}>
          <InfiniteScroll
            dataLength={orderData.length}
            next={loadMoreData}
            hasMore={orderData.length < pagination.totalCount}
            loader={<Spin spinning />}
            endMessage="已全部加载~"
            height={400}
          >
            <TableAntd
              dataSource={dataSourceMemo}
              loading={loading}
              listColumn={columns}
              scroll={{
                y: 'auto',
              }}
              onChangeCheck={onChangeCheck}
              defaultlist={checkedKeys}
              scrollStyle={{
                height: 'auto',
              }}
            />
          </InfiniteScroll>
        </Col>
      </Row>
    </CustomModal>
  )
}

export default AddReturnOrderModal
